<template>
    <div class="aptitudFisica-form">
        <div class="form-header">
            <span class="form-title h2">
                <i class="fa-solid fa-car"></i>
                Vehiculo
            </span>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">

            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarVehiculo" novalidate>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Placa" label-for="placa">
                                <b-form-input id="placa" v-model="form.placa" placeholder="Ej: ABC123" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="SOAT" label-for="soat">
                                <b-form-input id="soat" v-model="form.soat" placeholder="Ej: SOAT123456" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha Vencimiento SOAT" label-for="fechaVencimientoSoat">
                                <b-form-input id="fechaVencimientoSoat" v-model="form.fechaVencimientoSoat" type="date"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Revisión Técnico Mecánica" label-for="revisionTecnicoMecanica">
                                <b-form-input id="revisionTecnicoMecanica" v-model="form.revisionTecnicoMecanica"
                                    placeholder="Ej: REV123456" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha Revisión Técnico Mecánica"
                                label-for="fechaRevisionTecnicoMecanica">
                                <b-form-input id="fechaRevisionTecnicoMecanica"
                                    v-model="form.fechaRevisionTecnicoMecanica" type="date" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Póliza" label-for="idPolizas">
                                <b-form-input id="idPolizas" v-model="form.idPolizas" placeholder="Ej: POL123456"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tipo Póliza" label-for="tipoPoliza">
                                <b-form-input id="tipoPoliza" v-model="form.tipoPoliza" placeholder="Ej: Todo Riesgo"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Vigencia Póliza" label-for="vigencia">
                                <b-form-input id="vigencia" v-model="form.vigencia" type="date" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tarjeta Operación" label-for="tarjetaOperacion">
                                <b-form-input id="tarjetaOperacion" v-model="form.tarjetaOperacion"
                                    placeholder="Ej: TO123456" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha Tarjeta Operación" label-for="fechaTarjetaOperacion">
                                <b-form-input id="fechaTarjetaOperacion" v-model="form.fechaTarjetaOperacion"
                                    type="date" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Mantenimiento" label-for="idMatenimiento">
                                <b-form-input id="idMatenimiento" v-model="form.idMatenimiento"
                                    placeholder="Ej: MTTO123456" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha Mantenimiento" label-for="fechaMantenimiento">
                                <b-form-input id="fechaMantenimiento" v-model="form.fechaMantenimiento" type="date"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Protocolo Alistamiento Diario"
                                label-for="idProtocoloAlistamientoDiario">
                                <b-form-input id="idProtocoloAlistamientoDiario"
                                    v-model="form.idProtocoloAlistamientoDiario" placeholder="Ej: PAD123456" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha Protocolo Alistamiento Diario"
                                label-for="fechaProtocoloAlistamientoDiario">
                                <b-form-input id="fechaProtocoloAlistamientoDiario"
                                    v-model="form.fechaProtocoloAlistamientoDiario" type="date" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12">
                            <b-form-group label="Observaciones" label-for="observaciones">
                                <b-form-textarea id="observaciones" v-model="form.observaciones"
                                    placeholder="Sin observaciones" rows="3" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Clase" label-for="clase">
                                <b-form-input id="clase" v-model="form.clase" type="number" min="1" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Nivel Servicio" label-for="nivelServicio">
                                <b-form-input id="nivelServicio" v-model="form.nivelServicio" type="number" min="1"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Vehículo' }}
                        </b-button>
                    </div>
                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>


<script>
export default {
    name: 'FormularioVehiculo',
    data() {
        return {
            loading: false,
            collapsed: true,
            form: {
                placa: '',
                soat: '',
                fechaVencimientoSoat: '',
                revisionTecnicoMecanica: '',
                fechaRevisionTecnicoMecanica: '',
                idPolizas: '',
                tipoPoliza: '',
                vigencia: '',
                tarjetaOperacion: '',
                fechaTarjetaOperacion: '',
                idMatenimiento: '',
                fechaMantenimiento: '',
                idProtocoloAlistamientoDiario: '',
                fechaProtocoloAlistamientoDiario: '',
                observaciones: '',
                clase: null,
                nivelServicio: null
            }
        }
    },
    props: {
        preCarga: {
            type: Object,
            default: null

        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        placa: val.placa ?? '',
                        soat: val.soat ?? '',
                        fechaVencimientoSoat: val.fecha_vencimiento_soat ?? '',
                        revisionTecnicoMecanica: val.revision_tecnico_mecanica ?? '',
                        fechaRevisionTecnicoMecanica: val.fecha_revision_tecnico_mecanica ?? '',
                        idPolizas: val.id_polizas ?? '',
                        tipoPoliza: val.tipo_poliza ?? '',
                        vigencia: val.vigencia ?? '',
                        tarjetaOperacion: val.tarjeta_operacion ?? '',
                        fechaTarjetaOperacion: val.fecha_tarjeta_operacion ?? '',
                        idMatenimiento: val.id_matenimiento ?? '',
                        fechaMantenimiento: val.fecha_mantenimiento ?? '',
                        idProtocoloAlistamientoDiario: val.id_protocolo_alistamiento_diario ?? '',
                        fechaProtocoloAlistamientoDiario: val.fecha_protocolo_alistamiento_diario ?? '',
                        observaciones: val.observaciones ?? '',
                        clase: val.clase ?? null,
                        nivelServicio: val.nivel_servicio ?? null
                    };
                }
            }
        }
    },
    methods: {
        async registrarVehiculo() {
            this.loading = true;
            const data = { ...this.form };
            console.log("Formulario enviado:", data);
            this.$emit('submit', data, 'CrearVehiculo');
            this.loading = false;



        }

    }
}
</script>

<style scoped>
.aptitudFisica-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #ffffff;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}



.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
